import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useSheinShop } from '@/shein-platform/context/SheinShopContext';
import { sheinShopCapabilities } from '@/shein-platform/utils/sheinShopCapabilities';

/**
 * 价格处理路由壳：侧栏二级菜单「议价单 / 建议零售价」。
 */
export default function DiscussHubPage() {
  const location = useLocation();
  const { activeShop } = useSheinShop();
  const caps = sheinShopCapabilities(activeShop);
  const canDiscuss = Boolean(caps.canDiscussCost);
  const atRoot = /\/discuss\/?$/.test(location.pathname);

  if (atRoot) {
    return <Navigate to={canDiscuss ? 'cost' : 'rrp'} replace />;
  }

  return <Outlet />;
}
